import React from 'react'
import { Table, Label } from 'semantic-ui-react'
import * as R from 'ramda'
import styled from 'styled-components'
import Popup from 'shared/components/Popup'

const iconText = {
  positive: 'green smile',
  neutral: 'yellow meh',
  negative: 'red frown',
}

const labelColor = {
  positive: '!bg-green-lighter',
  neutral: '!bg-orange-lighter',
  negative: '!bg-red-lighter',
}

export const IconStyled = styled.div`
   {
    display: inline-flex;
    border: 1px solid #dedede;
    border-radius: 4px;
    padding: 4px;
    margin-right: 8px;
    margin-bottom: 4px;
    max-height: 26px;
  }
`

export function QuestionAction({
  condition,
  isOpinionScaleQuestion,
  choices,
  hasImplicitAnswerRule,
  shouldShowChoiceValueOnRule,
}) {
  return (
    <Table.Row>
      <Table.Cell className="tblcustom pleft align-top" width={6}>
        {hasImplicitAnswerRule ? (
          <Label basic>Any answer</Label>
        ) : (
          condition.rules.map((rule) => {
            const key = `${condition.id}-${rule}`
            if (R.includes(rule, ['positive', 'neutral', 'negative'])) {
              return (
                <Label key={key} className={`${labelColor[rule]}`}>
                  <span className={`text-${iconText[rule]}`}>
                    <span className="bold capitalize">{rule}</span>
                  </span>
                </Label>
              )
            } else {
              const choiceId = rule
              const choice = R.find((choice) => choice.id == choiceId, choices)
              const isDeletedChoiceStillInConditionLogic = R.isNil(choice)
              if (isDeletedChoiceStillInConditionLogic) {
                return null
              } else if (isOpinionScaleQuestion) {
                const text = shouldShowChoiceValueOnRule ? choice.value : choice.label
                return <SentimentLabel key={key} sentiment={choice.sentiment} text={text} />
              } else {
                return (
                  <Label key={key} style={{ margin: '2px' }} basic>
                    {choice.label}
                  </Label>
                )
              }
            }
          })
        )}
      </Table.Cell>
      <Table.Cell className="tblcustom pright align-top" width={10}>
        <NextStep condition={condition} />
      </Table.Cell>
    </Table.Row>
  )
}

function SentimentLabel({ sentiment, text }) {
  return (
    <Label className={`${labelColor[sentiment]}`} style={{ margin: '2px' }}>
      <span className={`text-${iconText[sentiment]}`}>
        <i className={`icon ${iconText[sentiment]}`} />
        <span className="bold">{text}</span>
      </span>
    </Label>
  )
}

const NextStep = ({ condition }) => {
  if (condition.action == 'finish_survey') {
    return (
      <div className="flex m-0.5">
        <Popup basic tooltip="Finish the survey">
          <IconStyled>
            <img
              style={{ width: '18px', color: '#9B9B9B' }}
              src="https://cdn.simplesat.io/images/arrow-turn-down-right.png"
              alt="finish-survey"
            />
          </IconStyled>
        </Popup>
        <span>Finish survey</span>
      </div>
    )
  } else if (condition.conditional_question_type == 'follow_up_comment_question') {
    return (
      <div className="flex m-0.5">
        <Popup basic tooltip="Ask a comment box follow-up question">
          <IconStyled>
            <i style={{ width: '18px' }} className="icon purple fas fa-quote-left" />
          </IconStyled>
        </Popup>
        <span>"{condition.follow_up_comment_question.text}"</span>
      </div>
    )
  } else if (condition.conditional_question_type == 'follow_up_file_upload_question') {
    return (
      <div className="flex m-0.5">
        <Popup basic tooltip="Ask a file upload follow-up question">
          <IconStyled>
            <i style={{ width: '18px' }} className="icon violet far fa-paperclip" />
          </IconStyled>
        </Popup>
        <span>"{condition.follow_up_file_upload_question.text}"</span>
      </div>
    )
  } else if (condition.conditional_question_type == 'follow_up_multiple_choice_question') {
    return (
      <div className="flex m-0.5">
        <Popup basic tooltip="Ask a multiple choice follow-up question">
          <IconStyled>
            <i style={{ width: '18px' }} className="icon green fas fa-list" />
          </IconStyled>
        </Popup>
        <span>"{condition.follow_up_multiple_choice_question.text}"</span>
      </div>
    )
  } else if (condition.conditional_question_type == 'follow_up_multi_select_choice_question') {
    return (
      <div className="flex m-0.5">
        <Popup basic tooltip="Ask a multiple select choice follow-up question">
          <IconStyled>
            <i style={{ width: '18px' }} className="icon blue fas fa-list-check" />
          </IconStyled>
        </Popup>
        <span>"{condition.follow_up_multi_select_choice_question.text}"</span>
      </div>
    )
  } else {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/components/QuestionActions/QuestionAction.tsx